import { Component, ElementRef, TemplateRef } from '@angular/core';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Module } from '../../models/module/module.model';
import { Router } from '@angular/router';
@Component({
    selector: 'app-side-nav',
    templateUrl: './side-nav.component.html',
    styleUrls: ['./side-nav.component.css']
})
/** side-nav component*/
export class SideNavComponent {
  public modules: Module[];

  el: ElementRef;
    /** side-nav ctor */
  constructor(private readonly router: Router,
    private readonly rolePermissionService: RolePermissionService,
    el: ElementRef) {

    this.el = el;

    this.rolePermissionService.GetSideBarPermissions().subscribe(
      data => {
        if (data != null) {
          this.modules = data;
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  } 

  IsAllowed(name: string) {

    if (this.modules != null && typeof this.modules != "undefined") {
      var permission = this.modules.filter(function (element) {
        return (element.component == name);
      });

      if (permission.length > 0) {
        return true;
      }
      else {
        return false;
      }
    }

    else {
      return false;
    }
  }



  //IsChildExist(template: TemplateRef<any>) {

  
  //  //const hostElem = document.getElementsByClassName("panel");//document.getElementByClassName()//this.el.nativeElement;
  

  //  //if (hostElem.length > 0) {
  //  //  hostElem.forEach(childElem => {
  
  //  //  });
  //  //}
  //}


  //ngAfterViewInit() {
  //  const hostElem = document.getElementsByClassName("panel");//document.getElementByClassName()//this.el.nativeElement;
  

  //  if (hostElem.length > 0)
  //  {
  //    hostElem.forEach(childElem => {
  
  //    });
  //  }
  
  //}
}



// WEBPACK FOOTER //
// ./src/app/ui-components/side-nav/side-nav.component.ts